module.exports = __webpack_public_path__ + "img/close.485ef9f0.svg";